import React from "react";
import { Link } from "react-router-dom";

// Custom 404 page shown when users visit an invalid frontend route.
const NotFoundPage = () => {

  // Choose a safe return page based on whether the user is logged in.
  const isAuthenticated = sessionStorage.getItem("authenticated") === "true";
  const safePath = isAuthenticated ? "/projects" : "/";

  return (
    <div className="flex items-center justify-center px-6 py-20">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm max-w-xl w-full text-center p-8">
        <div className="text-7xl font-extrabold text-[#0EA5E9] mb-4">
          404
        </div>

        <h1 className="text-3xl font-bold text-slate-900 mb-3">
          Page Not Found
        </h1>

        <p className="text-slate-500 text-sm leading-relaxed mb-6">
          The page you are looking for does not exist or the link may be broken.
          Please return to a safe page and continue using DEEBug.
        </p>

        <Link
          to={safePath}
          className="inline-flex items-center justify-center bg-[#0EA5E9] hover:bg-[#0284C7] text-white font-semibold px-5 py-2.5 rounded-lg shadow transition"
        >
          {isAuthenticated ? "Back to Projects" : "Back to Home"}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;